import { render } from "./ElementConfig.vue?vue&type=template&id=6bd3d50e&scoped=true"
import script from "./ElementConfig.vue?vue&type=script&lang=js"
export * from "./ElementConfig.vue?vue&type=script&lang=js"

import "./ElementConfig.vue?vue&type=style&index=0&id=6bd3d50e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd3d50e"]])

export default __exports__